import { useEffect, useState } from "react";
import { api } from "../../../utils/api";
import ExpertiseTile from "./ExpertiseTile";
import { expertiseGridClassName } from "./expertiseGrid";

/** فیلتر تخصص در لیست کارگاه / وبینار / کلیپ / درمانگر — همیشه همهٔ تخصص‌ها */
export default function CatalogExpertiseFilterSection({
	isDesktop,
	selectedExpertiseId,
	onExpertiseClick,
}) {
	const [expertises, setExpertises] = useState([]);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		api
			.expertiseList()
			.then((results) => {
				setExpertises(Array.isArray(results) ? results : []);
			})
			.catch((err) => {
				if (err?.data?.message) {
					setErrorMessage(err.data.message);
				}
			});
	}, []);

	return (
		<div className="w-full">
			<div className={expertiseGridClassName(isDesktop)}>
				{expertises.map((expertise, index) => (
					<ExpertiseTile
						key={expertise.id}
						expertise={expertise}
						isDesktop={isDesktop}
						index={index}
						isSelected={String(expertise.id) === String(selectedExpertiseId)}
						onClick={() => onExpertiseClick(expertise.id)}
					/>
				))}
			</div>
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">
					{errorMessage}
				</div>
			)}
		</div>
	);
}
